module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2370975.e23c562d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2370975.pdf
// module id = 854
// module chunks = 0